import axios, {type AxiosRequestConfig} from 'axios';

const YoutubeApi = {
    httpClient: axios.create({
        baseURL: 'https://www.googleapis.com/youtube/v3/',
        params: {
            part: 'snippet',
            key: import.meta.env.VITE_YOUTUBE_API_KEY,
            maxResults: 20,
        },
    }),
    get(endpoint: string, config: AxiosRequestConfig) {
        return this.httpClient.get(endpoint, config);
    },
};

export const getPlaylists = async () => {
    try {
        return YoutubeApi.get(`playlists`, {
            params: {
                channelId: 'UCTaeNiOlA7L9v0_dxeSK1uw', // 인천스마트경로당 채널ID
            },
        });
    } catch (e) {
        console.error(e);
    }
};

export const getPlaylistItems = async (playlistId: string) => {
    try {
        return YoutubeApi.get(`playlistItems`, {
            params: {
                playlistId: playlistId,
            },
        });
    } catch (e) {
        console.error(e);
    }
};

export const getUpcomingList = async () => {
    try {
        return YoutubeApi.get(`search`, {
            params: {
                channelId: 'UCTaeNiOlA7L9v0_dxeSK1uw', // 인천스마트경로당 채널ID
                type: 'video',
                eventType: 'upcoming',
            },
        });
    } catch (e) {
        console.error(e);
    }
};

export const getLiveList = async () => {
    try {
        return YoutubeApi.get(`search`, {
            params: {
                channelId: 'UCTaeNiOlA7L9v0_dxeSK1uw', // 인천스마트경로당 채널ID
                type: 'video',
                eventType: 'live',
            },
        });
    } catch (e) {
        console.error(e);
    }
};
